/*
  In the press (round 36): the little that moves on sections/vr-press.liquid.
  - every masthead and drawn name is cropped to its ink, so each stands at one optical height whatever padding its
    file carries (wide ones a little lower, tall ones a little higher);
  - the two bands of mastheads in the opening drift at one slow pace, and rest while they are off the screen;
  - each cover story is first seen closed, its page lying over the photograph with the masthead on its back, and
    turns open as it comes into view, once.
  Visitors who ask for reduced motion see the bands still and every page open.
*/
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SPEED = 26; /* pixels a second, for the bands of mastheads */

  /* ---- the extent of the ink of an image, measured once for each file ---- */
  var inks = {};
  function ink(url, done) {
    var c = inks[url];
    if (c) { if (c.ready) done(c.v); else c.q.push(done); return; }
    c = inks[url] = { ready: false, v: null, q: [done] };
    var im = new Image();
    im.crossOrigin = 'anonymous';
    var finish = function (v) { c.ready = true; c.v = v; c.q.forEach(function (f) { f(v); }); c.q = []; };
    im.onload = function () {
      try {
        if (!im.naturalWidth || !im.naturalHeight) { finish(null); return; }
        var W = 320, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var g = cv.getContext('2d'); g.drawImage(im, 0, 0, W, H);
        var d = g.getImageData(0, 0, W, H).data;
        var x0 = W, y0 = H, x1 = -1, y1 = -1;
        for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) { if (d[(y * W + x) * 4 + 3] > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
        if (x1 < 0) { finish(null); return; }
        var fw = (x1 + 1 - x0) / W, fh = (y1 + 1 - y0) / H, fx = x0 / W, fy = y0 / H;
        finish({
          ar: (fw * im.naturalWidth) / (fh * im.naturalHeight),
          size: (100 / fw).toFixed(2) + '% ' + (100 / fh).toFixed(2) + '%',
          pos: (fw >= 0.999 ? 50 : fx / (1 - fw) * 100).toFixed(2) + '% ' + (fh >= 0.999 ? 50 : fy / (1 - fh) * 100).toFixed(2) + '%'
        });
      } catch (e) { finish(null); /* a file the canvas may not read: shown whole */ }
    };
    im.onerror = function () { finish(null); };
    im.src = url;
  }
  function crop(el, url, target, lo, hi, after) {
    ink(url, function (v) {
      if (!v) return;
      el.style.setProperty('--ink-ar', v.ar.toFixed(4));
      el.style.setProperty('--ink-size', v.size);
      el.style.setProperty('--ink-pos', v.pos);
      el.style.setProperty('--ink-boost', Math.min(hi, Math.max(lo, Math.sqrt(target / v.ar))).toFixed(3));
      el.classList.add('is-measured');
      if (after) after();
    });
  }

  /* ---- the bands of mastheads: one slow pace whatever their length ---- */
  function pace(root) {
    root.querySelectorAll('[data-vrp-track]').forEach(function (t) {
      var w = t.scrollWidth / 2;
      if (w > 0) t.style.setProperty('--drift', Math.max(60, w / SPEED).toFixed(1) + 's');
    });
  }

  function init(root) {
    var vrp = root.matches && root.matches('[data-vrp]') ? root : root.querySelector('[data-vrp]');
    if (!vrp || vrp.dataset.vrpReady) return;
    vrp.dataset.vrpReady = '1';

    var open = vrp.querySelector('[data-vrp-open]');
    var paceTimer = 0;
    var repace = function () { window.clearTimeout(paceTimer); paceTimer = window.setTimeout(function () { pace(vrp); }, 120); };
    vrp.querySelectorAll('[data-vrp-mast]').forEach(function (m) { crop(m, m.getAttribute('data-vrp-mast'), 3, 0.74, 1.46, repace); });
    vrp.querySelectorAll('[data-vrp-ink]').forEach(function (m) { crop(m, m.getAttribute('data-vrp-ink'), 2.4, 0.78, 1.42); });
    pace(vrp);
    window.addEventListener('resize', repace);
    if (open && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { open.classList.toggle('is-still', !e.isIntersecting); }); }).observe(open);
    }

    /* the cover stories: closed below the fold, turned open as each comes into view */
    if (reduce || !('IntersectionObserver' in window)) return;
    var spreads = Array.prototype.slice.call(vrp.querySelectorAll('[data-vrp-spread]'));
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || e.intersectionRatio < 0.32) return;
        var sp = e.target;
        io.unobserve(sp);
        window.setTimeout(function () { sp.classList.add('is-open'); }, 220);
      });
    }, { threshold: [0, 0.32, 0.5] });
    spreads.forEach(function (sp) {
      var r = sp.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.8) return; /* already in sight when the page opens: shown open */
      sp.classList.add('is-armed');
      io.observe(sp);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
